import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		height: '100%',
		width: '100%',
		paddingLeft: 20,
		paddingRight: 20,
		flex: 1,
	},
	modalContainer: {
		padding: '0 20px',
	},
	editor: {
		boxSizing: 'border-box',
		height: '100%',
		paddingTop: 26,
	},
});
